import React from 'react';
import { ArrowRight } from 'lucide-react';
import { usePublicEvents } from '../hooks/usePublicEvents';
import { RouteLink } from '../lib/router';
import { formatLongDate, formatTime } from '../utils/eventDates';

/**
 * Slim announcement strip for the next event. Sits directly under the hero so
 * an arriving visitor sees a time-sensitive date before choosing a pathway.
 */
export function EventAnnouncement() {
  const {
    events
  } = usePublicEvents();
  const [next] = events;
  if (!next) return null;
  const doors = formatTime(next.doorsTime);
  const when = [formatLongDate(next.eventDate), doors ? `Doors ${doors}` : null].filter(Boolean).join(' · ');
  return <aside className="bg-pine text-cream" data-id="element-222" data-mp="2bnb5k6brd6k3">
      <RouteLink to="/space#events" className="group mx-auto flex max-w-6xl flex-col gap-2 px-6 py-4 transition-colors hover:bg-pineDeep sm:flex-row sm:items-center sm:gap-6 md:px-12" data-id="element-223" data-mp="2bm9rru3cy5yo">
        <span className="flex-none text-xs font-medium uppercase tracking-[0.2em] text-gold" data-id="element-224" data-mp="108xqnqyzg1g7">
          Next event
        </span>
        <span className="flex flex-1 flex-wrap items-baseline gap-x-3 gap-y-1" data-id="element-225" data-mp="1q64hmpspaiwq">
          <span className="font-serif text-lg leading-snug" data-id="element-226" data-mp="1l71bt34wc8np">{next.title}</span>
          <span className="text-sm font-light text-sand/80" data-id="element-227" data-mp="2038uu04kj41e">{when}</span>
        </span>
        <span className="flex flex-none items-center gap-2 whitespace-nowrap text-sm font-medium" data-id="element-228" data-mp="1v2crbno4pjwi">
          View details
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" data-id="element-229" data-mp="291kv6tv8lg71" />
        </span>
      </RouteLink>
    </aside>;
}